/** Onboarding hints shown when the chat has no turns yet. Persian-first. */
export function AssistantEmptyState() {
  return (
    <div className="rounded-lg border border-dashed border-border bg-muted/20 p-3 text-xs space-y-2">
      <p className="font-medium text-foreground">مثال‌ها:</p>
      <ul className="text-muted-foreground space-y-1 list-disc list-inside">
        <li>یک فیلد قد به سانتی‌متر اضافه کن، اجباری، بین ۳۰ تا ۲۵۰.</li>
        <li>برای وزن، اگر مقدار خارج از بازه ۳۰ تا ۲۵۰ بود هشدار نرم بده.</li>
        <li>اگر سن کمتر از ۱۸ است، فیلد سابقه بارداری را پنهان کن.</li>
      </ul>
    </div>
  )
}
